import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './IncentiveCard.scss';
import GaTracker from './../../utils/GaTracker/GaTracker';
import { useIntl } from 'react-intl';
import undo from '../../client_customizations/assets/images/icons/undo.svg';

const IncentiveCard = (props) => {
  const intl = useIntl();

  const [showMore, setShowMore] = useState(false);
  let incentive = props && props.incentive ? props.incentive : {};
  console.log(incentive);

  let purchaseMethod =
    props && props.purchaseMethod ? props.purchaseMethod : '';

  let incentiveGrantors = {
    Federal: intl.formatMessage
      ? intl.formatMessage({ id: 'grantor.federal', defaultMessage: 'Federal' })
      : 'Federal',
    State: intl.formatMessage
      ? intl.formatMessage({ id: 'grantor.state', defaultMessage: 'State' })
      : 'State',
    Local: intl.formatMessage
      ? intl.formatMessage({ id: 'grantor.local', defaultMessage: 'Local' })
      : 'Local',
    SMUD: intl.formatMessage
      ? intl.formatMessage({ id: 'grantor.smud', defaultMessage: 'SMUD' })
      : 'SMUD',
    Utility: intl.formatMessage
      ? intl.formatMessage({ id: 'grantor.utility', defaultMessage: 'Utility' })
      : 'Utility',
  };

  let incentiveTypes = {
    'Bill Credit': intl.formatMessage
      ? intl.formatMessage({ id: 'billCredit', defaultMessage: 'bill credit' })
      : 'Bill credit',
    'Discounted Electric Rate': intl.formatMessage
      ? intl.formatMessage({
          id: 'discountedElectricRate',
          defaultMessage: 'Discounted electric rate',
        })
      : 'Discounted electric rate',
    Financing: intl.formatMessage
      ? intl.formatMessage({ id: 'financing', defaultMessage: 'Financing' })
      : 'Financing',
    'Free Equipment': intl.formatMessage
      ? intl.formatMessage({
          id: 'freeEquipment',
          defaultMessage: 'free equipment',
        })
      : 'Free equipment',
    'HOV Lane': intl.formatMessage
      ? intl.formatMessage({ id: 'hovLane', defaultMessage: 'HOV lane' })
      : 'HOV lane',
    'Insurance Discount': intl.formatMessage
      ? intl.formatMessage({
          id: 'insuranceDiscount',
          defaultMessage: 'Insurance discount',
        })
      : 'Insurance Discount',
    'Parking Exemption': intl.formatMessage
      ? intl.formatMessage({
          id: 'parkingExemption',
          defaultMessage: 'Parking exemption',
        })
      : 'Parking exemption',
    'Public Charging': intl.formatMessage
      ? intl.formatMessage({
          id: 'publicCharging',
          defaultMessage: 'public charging',
        })
      : 'public charging',
    Rebate: intl.formatMessage
      ? intl.formatMessage({ id: 'rebate', defaultMessage: 'rebate' })
      : 'Rebate',
    'Tax Credit': intl.formatMessage
      ? intl.formatMessage({ id: 'taxCredit', defaultMessage: 'tax credit' })
      : 'tax credit',
    'Tax Exemption': intl.formatMessage
      ? intl.formatMessage({
          id: 'taxExemption',
          defaultMessage: 'tax exemption',
        })
      : 'tax exemption',
    'Toll Discount': intl.formatMessage
      ? intl.formatMessage({
          id: 'tollDiscount',
          defaultMessage: 'toll discount',
        })
      : 'toll Discount',
    'Federal Tax Credit': intl.formatMessage
      ? intl.formatMessage({
          id: 'federalTaxCredit',
          defaultMessage: 'Federal tax credit',
        })
      : 'Federal tax credit',
    'Vehicle Retirement': intl.formatMessage
      ? intl.formatMessage({
          id: 'vehicleRetirement',
          defaultMessage: 'Vehicle Retirement',
        })
      : 'Vehicle Retirement',
  };

  let description = incentive.description || '';

  const truncateText = (text, max = 25) => {
    if (!text) return 'None';

    if (text.length > max) {
      return text.substring(0, max);
    } else return text;
  };

  const handleShowClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setShowMore((s) => !s);
  };

  const handleClick = () => {
    GaTracker.trackEvent({
      category: 'Incentives',
      action: 'Clicked on Incentive Card',
      label: `${incentive.name}`,
    });
  };

  const formatUSD = (n) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    }).format(n);

  const getIncentiveAmount = (incentive, purchaseMethod) => {
    const evalAmount =
      purchaseMethod === 'lease'
        ? incentive?.evaluation?.amount_in_lease
        : purchaseMethod === 'cash' || purchaseMethod === 'loan'
        ? incentive?.evaluation?.amount_in_purchase
        : undefined;

    if (evalAmount > 0) {
      return formatUSD(evalAmount);
    }

    return incentive?.typical_amount !== 'N/A'
      ? String(incentive?.typical_amount)
      : '';
  };
  const incentiveAmount = getIncentiveAmount(incentive, purchaseMethod);

  let renderCard =
    incentive && !props.displayNone ? (
      <a
        className={`${props.displayNone ? 'displayNone' : 'IncentiveCard'} ${
          showMore ? 'showAllCard' : ''
        }`}
        href={incentive.details_url}
        target="_blank"
        rel="noopener noreferrer"
        data-incentive-id={incentive.id}
        onClick={() => handleClick()}
      >
        {!showMore ? (
          <>
            <div className={`IncentiveCardTop`}>
              <span>
                {(incentiveGrantors[incentive.grantor] || incentive.grantor) +
                  ' ' +
                  (incentiveTypes[incentive.type] || incentive.type)}
              </span>
            </div>
            <div className="IncentiveCardBody">
              <p className="h1 card-title">{incentiveAmount}</p>
              <p className="h2 light">{incentive.name}</p>
            </div>
            <div className="pl-2 pr-2 hrContainer">
              <hr />
            </div>
          </>
        ) : null}

        <div
          className={
            showMore ? 'IncentiveCardBottom active' : 'IncentiveCardBottom'
          }
        >
          <div className="incentive-card-bottom-content">
            {showMore ? description : truncateText(description, 0)}
          </div>
          <div className={showMore ? 'showBtn' : 'applyBtn'}>
            {showMore ? (
              <div className="readLess">
                <button className="undo" onClick={handleShowClick} tabIndex={0}>
                  <img src={undo} alt="undo" />
                </button>
                <a
                  className="btn btn-smud-secondary"
                  href={incentive.details_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => handleClick()}
                >
                  {intl.formatMessage({
                    id: 'incentiveCard.more',
                    defaultMessage: 'Learn more',
                  })}
                </a>
              </div>
            ) : (
              <>
                <button
                  className="btn btn-smud"
                  onClick={handleShowClick}
                  tabIndex={0}
                >
                  {intl.formatMessage({
                    id: 'incentiveCard.seeMore',
                    defaultMessage: 'Incentive description',
                  })}
                </button>
              </>
            )}
          </div>
        </div>
      </a>
    ) : null;

  return renderCard;
};

export default IncentiveCard;

IncentiveCard.propTypes = {
  incentive: PropTypes.object,
  compact: PropTypes.bool,
};
